import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllClearingEvents } from '../../actions/ssmActions';
import CreateEvent from './CreateEvent';
import DisplayGrid from './DisplayGrid';
import ScanInput from './ScanInput';
import BatchExcel from './BatchExcel';
import BatchStorage from './BatchStorage';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { handleStorageScanManagement } from '../../reducers/uiSlice';
import { openStorageScanManagement } from '../../reducers/uiSlice';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.background.paper,
      minHeight: '80vh'
    },
  }));

function StorageScan() {
    const classes = useStyles();
    const {t} = useTranslation('storageScan');
    const dispatch = useDispatch();

    const [warehouse, setWarehouse] = useState('');

    const openModal = useSelector(openStorageScanManagement);
    
    if (openModal === true) {
        dispatch(getAllClearingEvents());
    }

    return (
        <Dialog 
            onClose={handleClose} 
            open={openModal}
            fullWidth={true}
            maxWidth='xl'
            scroll='body'
        >    
            <DialogTitle>
                {t('title_storage_scan')}
                <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
                    <CloseIcon onClick={handleClose}></CloseIcon>
                </Tooltip>                                   
            </DialogTitle>
            <DialogContent dividers  className={classes.root} >
                <div>
                    <CreateEvent />
                    <DisplayGrid 
                        handleWarehouse={handleWarehouse}
                    />
                    <ScanInput />
                    <BatchExcel 
                        warehouse={warehouse}
                    />
                    <BatchStorage 
                        warehouse={warehouse}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );

     /**
     * close the dialog
     */
    function handleClose() {
        dispatch(handleStorageScanManagement(false))
    }

    function handleWarehouse(warehouse) {
        setWarehouse(warehouse);
    }
}

export default StorageScan